import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'sg365_offer_end';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getEndTime(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  const parsed = stored ? parseInt(stored, 10) : 0;
  const now = Date.now();
  if (!parsed || isNaN(parsed) || parsed <= now) {
    const next = now + DURATION_MS;
    window.localStorage.setItem(STORAGE_KEY, String(next));
    return next;
  }
  return parsed;
}
function format(n: number): string {
  return n.toString().padStart(2, '0');
}
export function Countdown() {
  const [endTime, setEndTime] = useState<number>(() => getEndTime());
  const [now, setNow] = useState<number>(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    if (now >= endTime) {
      const next = Date.now() + DURATION_MS;
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(STORAGE_KEY, String(next));
      }
      setEndTime(next);
    }
  }, [now, endTime]);
  const remaining = Math.max(0, endTime - now);
  const hours = Math.floor(remaining / (60 * 60 * 1000));
  const minutes = Math.floor(remaining % (60 * 60 * 1000) / (60 * 1000));
  const seconds = Math.floor(remaining % (60 * 1000) / 1000);
  return <div className="inline-flex flex-col items-center gap-2 px-5 py-4 rounded-xl border-2 shadow-md" style={{
    background: '#1A3257',
    borderColor: '#FFD700'
  }} data-id="element-365">
      <p className="text-white text-xs sm:text-sm font-semibold tracking-wide" data-id="element-366">
        ⏳ Ta oferta wygasa za:
      </p>
      <div className="flex items-start gap-2 sm:gap-3" data-id="element-367">
        <TimeBlock value={format(hours)} label="GODZINY" data-id="element-368" />
        <span className="font-display font-bold text-2xl sm:text-3xl md:text-4xl leading-none pt-1" style={{
        color: '#FFD700'
      }} data-id="element-369">
          :
        </span>
        <TimeBlock value={format(minutes)} label="MINUTY" data-id="element-370" />
        <span className="font-display font-bold text-2xl sm:text-3xl md:text-4xl leading-none pt-1" style={{
        color: '#FFD700'
      }} data-id="element-371">
          :
        </span>
        <TimeBlock value={format(seconds)} label="SEKUNDY" data-id="element-372" />
      </div>
    </div>;
}
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center min-w-[48px] sm:min-w-[60px]" data-id="element-373">
      <span className="font-display font-bold text-3xl sm:text-4xl md:text-5xl leading-none tabular-nums" style={{
      color: '#FFD700'
    }} data-id="element-374">
        {value}
      </span>
      <span className="text-[9px] sm:text-[10px] text-white/80 font-semibold tracking-wider mt-1" data-id="element-375">
        {label}
      </span>
    </div>;
}